// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__1w0lV","footerText":"Footer_footerText__2uHpc","companyName":"Footer_companyName__2arGC"};